import React from "react";
import {Space, Typography} from "antd";
import {ColumnsType} from "antd/lib/table/interface";
import {HealthCheck, HealthCheckGroup} from "../../../../models/health-checker/health-checker";
import {useTranslate} from "../../../../hooks/translate.hook";
import {DashboardGroup} from "./dashboard.group";

const {Text, Title} = Typography;

interface DashboardGroupsProps {
    groups: HealthCheckGroup[];
    columns: ColumnsType<HealthCheck>;
}

export const DashboardGroups: React.FC<DashboardGroupsProps> = ({groups, columns}) => {
    const t = useTranslate();

    return (
        <section className="health-center-dashboard__groups">
            <div className="health-center-dashboard__section-heading">
                <div>
                    <Title level={4}>
                        {t("HEALTH-CENTER.DASHBOARD.BY-GROUPS", {defaultValue: "All checks by group"})}
                    </Title>
                    <Text type="secondary">
                        {t("HEALTH-CENTER.DASHBOARD.BY-GROUPS-DESCRIPTION", {
                            defaultValue: "Full status and execution schedule for every check",
                        })}
                    </Text>
                </div>
            </div>

            <Space direction="vertical" size={16} className="health-center-dashboard__group-list">
                {groups.map((group) => (
                    <DashboardGroup key={group.id} group={group} columns={columns} />
                ))}
            </Space>
        </section>
    );
};
